<template>
  <BLayout :colors="$site.colors" :header-title="title" :header-back-route="homeRoute">
    <BContainer class="mt-12">
      <UModal
        v-model="active"
        fullscreen
        :ui="{
          background: 'bg-primary/60 backdrop-blur'
        }"
      >
        <div class="h-full w-full relative">
          <div class="absolute top-0 right-0 p-4 z-10">
            <UButton color="gray" variant="ghost" icon="i-heroicons-x-mark" class="-my-1" @click="active = false" />
          </div>
          <UCarousel
            ref="carouselRef"
            v-slot="{ item }"
            :items="images"
            arrows
            indicators
            class="h-full w-full"
          >
            <div class="flex items-center justify-center h-screen w-screen" @click="active = false">
              <img :src="item.url" draggable="false" class="rounded pointer-events-none" >
            </div>
          </UCarousel>
        </div>
      </UModal>
      <div v-if="$site.tabs.gallery && $site.tabs.gallery.images.length > 0" class="mb-5 text-center grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        <span
          v-for="(item, i) in $site.tabs.gallery.images"
          :key="i"
          class="h-50 w-full block rounded hover:scale-105 transition-all cursor-pointer overflow-hidden"
          @click="handleClickImage(i)"
        >
          <img :src="item.medium" class="h-full w-full object-cover">
      </span>
      </div>
    </BContainer>
  </BLayout>
</template>

<script setup lang="ts">
const { $site } = useNuxtApp()

definePageMeta({
  tabs: ['gallery'],
  middleware: ['redirects']
})

useTabMeta('gallery')

const selected = ref(null)
const carouselRef = ref()

const images = computed(() => {
  return $site.tabs.gallery.images.map((image) => {
    return {
      title: null,
      url: image.large
    }
  })
})

const active = computed({
  get: () => selected.value !== null,
  set: (value) => {
    if (!value) {
      selected.value = null
    }
  }

})

const title = computed(() => {
  return $site.tabs.gallery.name
})

const info = computed(() => {
  return $site.tabs.getInfo('gallery')
})

const homeRoute = computed(() => {
  const locationStore = useLocationStore()

  return locationStore?.homeRoute || { path: '/' }
})

const handleClickImage = async (index) => {
  selected.value = index

  setTimeout(() => {
    carouselRef.value.select(index + 1)
  }, 100)
}

</script>
